import React, { useState } from "react";
import mira from "../../assets/equipments/pendulum/pendulum.png";
import balance from "../../assets/equipments/balance_swing/balance-swing.png";
import clovis from "../../assets/equipments/spring_clovis/spring-clovis-1.png";
import autoSmart from "../../assets/equipments/auto_smart/auto_smart_1.jpg";
import quadroSimple from "../../assets/equipments/quadro_simple_50/qs_50_1.jpg";
import quadroSimple1243 from "../../assets/equipments/quadro_simple_1243/qs_1243_1.jpg";
import ticketOffice from "../../assets/equipments/ticket_office/tk_office_1.jpg";
import multiLadder from "../../assets/equipments/multi_ladder/multi_ladder_1.jpg";
import hags from "../../assets/hags.png";
import playtop from "../../assets/playtop.png";
import novum from "../../assets/novum.png";
import ProductCard from "../ProductCard";
import CustomButton from "../common/CustomBtn";
import { terra_house_simple_1 } from "../../assets";
import { useTranslation } from "react-i18next";

const ITEMS_PER_PAGE = 4;

const EshopPlayground = () => {
  const { t } = useTranslation("playgrounds");
  const playgroundData = [
    {
      img: mira,
      title: t("product1Title"),
      desc: t("product1Desc"),
      path: "/el-parduotuve/zaidimu-aiksteles/p=playgroundsproduct1title",
      partners: [{ logo: hags, path: "https://www.hags.com/home" }],
    },
    {
      img: clovis,

      title: t("product2Title"),
      desc: t("product2Desc"),
      path: "/el-parduotuve/zaidimu-aiksteles/p=playgroundsproduct2title",
      partners: [{ logo: novum, path: "https://novum4kids.com/" }],
    },
    {
      img: balance,
      title: t("product3Title"),
      desc: t("product3Desc"),
      path: "/el-parduotuve/zaidimu-aiksteles/p=playgroundsproduct3title",
      partners: [
        { logo: hags, path: "https://www.hags.com/home" },
        { logo: playtop, path: "https://www.playtop.com" },
      ],
    },
    {
      img: quadroSimple1243,
      title: t("product4Title"),
      desc: t("product4Desc"),
      path: "/el-parduotuve/zaidimu-aiksteles/p=playgroundsproduct4title",
      partners: [{ logo: novum, path: "https://novum4kids.com/" }],
    },
    {
      img: quadroSimple,
      title: t("product5Title"),
      desc: t("product5Desc"),
      path: "/el-parduotuve/zaidimu-aiksteles/p=playgroundsproduct5title",
      partners: [{ logo: novum, path: "https://novum4kids.com/" }],
    },
    {
      img: ticketOffice,
      title: t("product6Title"),
      desc: t("product6Desc"),
      path: "/el-parduotuve/zaidimu-aiksteles/p=playgroundsproduct6title",
      partners: [{ logo: novum, path: "https://novum4kids.com/" }],
    },
    {
      img: autoSmart,
      title: t("product7Title"),
      desc: t("product7Desc"),
      path: "/el-parduotuve/zaidimu-aiksteles/p=playgroundsproduct7title",
      partners: [{ logo: novum, path: "https://novum4kids.com/" }],
    },
    {
      img: multiLadder,
      title: t("product8Title"),
      desc: t("product8Desc"),
      path: "/el-parduotuve/zaidimu-aiksteles/p=playgroundsproduct8title",
      partners: [{ logo: novum, path: "https://novum4kids.com/" }],
    },
    {
      img: terra_house_simple_1,
      title: t("product9Title"),
      desc: t("product9Desc"),
      path: "/el-parduotuve/zaidimu-aiksteles/p=playgroundsproduct9title",
      partners: [{ logo: novum, path: "https://novum4kids.com/" }],
    },
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(playgroundData.length / ITEMS_PER_PAGE);

  const currentData = playgroundData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE,
  );

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };
  return (
    <section className="relative w-full h-full">
      <div className="w-full px-[5%]">
        <div className="pt-12 pb-16 maxContainer">
          <h2 className="mb-4 text-sm font-bold ss:text-md ">
            {/* Certified <span className="text-primary">Playground</span> Equipment */}
            {t("equipmentHeading")}
          </h2>
          <p className="mb-12 text-greyText">{t("equipmentDesc")}</p>

          <div className="grid justify-between grid-cols-1 gap-10 ss:gap-5 md:gap-12 ss:grid-cols-2">
            {currentData.map((card, index) => (
              <ProductCard key={index} {...card} />
            ))}
          </div>

          {playgroundData.length > ITEMS_PER_PAGE && (
            <div className="flex items-center justify-center gap-4 mt-10">
              <CustomButton
                onClick={handlePrev}
                disabled={currentPage === 1}
                className="disabled:opacity-40"
              >
                Previous
              </CustomButton>
              <span className="text-gray-500 text-[12px]">
                {currentPage} / {totalPages}
              </span>
              <CustomButton
                onClick={handleNext}
                disabled={currentPage === totalPages}
                className=" disabled:opacity-40"
              >
                Next
              </CustomButton>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default EshopPlayground;
